<div class="h-full flex flex-col w-full min-w-0 overflow-hidden p-2">
    <!-- Back Button -->
    <div class="m-2 flex flex-row items-center cursor-pointer" (click)="goBack()">
        <i class="pi pi-chevron-left text-sm"></i>
        <span class="font-bold text-sm ml-2">{{ 'Review clauses' | textCase }}</span>
    </div>

    <!-- Tabs - Responsive -->
    <div class="w-full overflow-x-auto">
        <p-tabs [value]="getActiveTabValue()" class="custom-tabview w-full">
            <p-tablist>
                <p-tab *ngFor="let item of tabs; let index = index" [value]="index.toString()" pRipple
                    [routerLink]="item.routerLink" class="flex items-center !gap-2">
                    <a class="p-menuitem-link flex items-center gap-2"
                        [ngClass]="{'active-tab': isActive(item.routerLink)}">
                        <span class="ml-2 text-gray-500 font-sans text-sm whitespace-nowrap"
                            [ngClass]="{'text-gray-500': !isActive(item.routerLink)}">{{ item.label | textCase }}</span>
                    </a>
                </p-tab>
            </p-tablist>
        </p-tabs>
    </div>

    <!-- Router Outlet -->
    <div class="flex-1 min-h-0 overflow-hidden w-full">
        <router-outlet></router-outlet>
    </div>
</div>